import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { useHistory, withRouter } from "react-router";
import { connect } from "react-redux";
import AdminOrderInfo from "../AdminOrderInfo/AdminOrderInfo";
import RefundOrder from "../RefundOrder/RefundOrder";
import CancelAdminOrder from "../CancelAdminOrder/CancelAdminOrder";
import { RefundDetails } from "../RefundsDetails/RefundDetails";
import { createAction } from "../../../utils/sagaHelper";
import {
    ADMIN_ORDER_GET_ORDER_INFO,
    ADMIN_ORDER_RESHIPMENT,
} from "../../../store/reducers/order/order-actions";
import { BUSINESS_MENU_GET, GIFT_CARD_GET } from "../../../store/reducers/restaurant/restaurant-actions";
import { getOrderMenuProducts } from "../../../services/restaurant";
import {
    BASIC_PATH, CUSTOMER_SERVICE_MODEL,
    EXTERNAL_COURIER_PROVIDER,
    MODEL_TYPE,
    PAY_METHOD,
} from '../../../utils/enums';
import { useTranslation } from "react-i18next";
import "./style.scss";
import CapturePaymentOrder from "../CapturePaymentOrder";
import AddDish from '../AddDish/index.js';
import { getInitModel } from '../../../services/initModels.js';
import { toast } from 'react-toastify';
import { editCustomerOrderModel } from "../../../models/editCustomerOrderModel.js";
import {
    REPEAT_ORDER,
    resetCustomerOrderEditInfo
} from "../../../store/reducers/editCustomerOrder/editCustomerOrder-action.js";
import IconButton from "../IconButton/IconButton.jsx";
import { Spin } from 'antd';

const CustomerServiceOrders = ({
    isMobile,
    territories,
    adminOrdersLoading,
    reshipmentOrder, onRepeatOrder, updateItem, isLoading,
    getOrderInfo, getGiftCardInfo, enableCallCenterMode, getBusinessMenu, saveOrderToEdit, item, customTableConfigKey, showBackButton, onClickBackButton, closeIcon,
}) => {
    const history = useHistory();
    const { t } = useTranslation();
    const [orderRefundId, setOrderRefundId] = useState(null);
    const [isOpenRefund, setIsOpenRefund] = useState(false);
    const [refundId, setRefundId] = useState(null);
    const [reshipmentOpen, setReshipmentOpen] = useState(false);
    const [refundOpen, setRefundOpen] = useState(false);
    const [cancelOrderOpen, setCancelOrderOpen] = useState(false);
    const [capturePaymentId, setCapturePaymentId] = useState(null);
    const [order, setOrder] = useState(() => item);
    const selectedOrderId = item.id;
    const orderMenuProduct = getOrderMenuProducts(order);
    const reshipmentOrderValue = (orderMenuProduct && getInitModel(MODEL_TYPE.reshipmentOrder, {
        currency: orderMenuProduct.currency,
        products: orderMenuProduct.items
    })) || {};

    const selectedOrderIdRef = useRef(selectedOrderId);

    useEffect(() => {
        selectedOrderIdRef.current = selectedOrderId;
    }, [selectedOrderId]);

    useEffect(() => {
        if (item) {
            getOrderInfo(item).then(data => setOrder(data));
        }
    }, [getOrderInfo, item]);

    useEffect(() => {
        getGiftCardInfo();
        // eslint-disable-next-line
    }, [getGiftCardInfo]);

    const handleOnClickPrevoius = () => {
    }

    const handleOnClickNext = () => {
    }

    const handleOnReshipment = () => {
        setReshipmentOpen(true);
        getBusinessMenu(order.business_id);
    }

    const handleOnReshipmentClose = () => {
        return new Promise(resolve => {
            resolve();
            setReshipmentOpen(false);
        });
    }

    const handleOnSave = (data) => {
        return new Promise((resolve, reject) => {
            resolve();
            reshipmentOrder(data).then(() => {
                resolve();
                handleOnReshipmentClose();
            }, error => {
                reject(error);
                toast(error);
            });
        })
    }

    const handleOnRefund = (id) => {
        setRefundOpen(true);
        setRefundId(id);
    }

    const handleOnRefundClose = () => {
        return new Promise(resolve => {
            resolve();
            setRefundOpen(false);
        });
    }

    const handleOnCancelOrder = () => {
        setCancelOrderOpen(true);
    }

    const handleOnCancelOrderClose = () => {
        return new Promise(resolve => {
            resolve();
            setCancelOrderOpen(false);
        });
    }

    const handleOnClose = () => {
    }

    const handleOnSetEditOrder = (orderId) => {
        return new Promise((resolve, reject) => {
            saveOrderToEdit({
                ...editCustomerOrderModel({
                    ...order,
                    // products: order.items
                }),
                orderInfo: order,
            })
            history.push(BASIC_PATH.editCustomerOrder + "?orderId=" + orderId);
            resolve();
        })
    }
    const handleOnRepeatOrder = (orderId) => {
        return new Promise((resolve, reject) => {
            onRepeatOrder({ ...order, fetchUserData: true });
            history.push("/create-order");
            resolve();
        })
    }

    const handleOnSearchId = () => {
        if (order.customer_id) {
            history.push(CUSTOMER_SERVICE_MODEL.customers + "?userId=" + order.customer_id);
        }
    }

    const getRefundsById = refundId => {
        return (refundId &&
            ((order || {}).refunds || []).filter(r => r.payment_id === refundId)
        ) || [];
    }

    const closeRefundLayout = () => {
        setOrderRefundId(null);
        setIsOpenRefund(false);
    }

    const onOpenRefunds = id => {
        setOrderRefundId(id);
        setIsOpenRefund(true);
    }

    const getMaxAmount = paymentId => {
        return (orderMenuProduct.payments || []).find(p => p.id === paymentId).refund_remainder || order.refund_remainder;
    }

    const handleOnCapture = paymentId => {
        setCapturePaymentId(paymentId);
    }

    const getPayment = paymentId => {
        return (orderMenuProduct.payments || []).find(p => p.id === paymentId);
    }

    const isBonusRefund = () => {
        const payment = orderMenuProduct.payments.find(p => p.id === refundId);
        if (payment) {
            return payment.paymethod_id === PAY_METHOD.cash
                || (payment.paymethod_id === PAY_METHOD.bonus && !payment.reference_Id)
                || (payment.paymethod_id === PAY_METHOD.creditCard && payment.provider === EXTERNAL_COURIER_PROVIDER.external);
        } else {
            return false;
        }
    }

    const isCardTerminalRefund = () => {
        const payment = orderMenuProduct.payments.find(p => p.id === refundId);
        if (payment) {
            return payment.paymethod_id === PAY_METHOD.cardTerminal;
        } else {
            return false;
        }
    }

    const handleOnCloseModal = () => {
        handleOnRefundClose();
        closeRefundLayout();
        handleOnCancelOrderClose();
        setCapturePaymentId(null);
        handleOnReshipmentClose();
    }

    return (
        <div className={"adminOrders"}>
            <Spin spinning={isLoading} className="adminOrdersSpiner"/>
            {selectedOrderId && order && (
                <AdminOrderInfo isMobile={isMobile} order={orderMenuProduct}
                    customTableConfigKey={customTableConfigKey}
                    updateItem={updateItem}
                    territories={territories}
                    openRefundsById={onOpenRefunds}
                    onClickPrevious={handleOnClickPrevoius}
                    onClickNext={handleOnClickNext}
                    onReshipment={handleOnReshipment}
                    onRefund={handleOnRefund}
                    onCancelOrder={handleOnCancelOrder}
                    onClose={handleOnClose}
                    onSearchId={handleOnSearchId}
                    setEditOrder={handleOnSetEditOrder}
                    onRepeatOrder={handleOnRepeatOrder}
                    onCapture={handleOnCapture}
                    showBackButton={showBackButton}
                    onClickBackButton={onClickBackButton}
                    closeIcon={closeIcon}
                />
            )}
            <div className={classNames("layoutContainer", { open: refundOpen || cancelOrderOpen || isOpenRefund || !!capturePaymentId || reshipmentOpen })}>
                <div className={'controlItemReview'}>
                    <button className={'backBtn'} onClick={handleOnCloseModal}>
                        <IconButton isIcon iconName={'smallArrow'} />
                        {t('basic.BACK_BUTTON')}
                    </button>
                </div>
                {reshipmentOpen && (
                    <AddDish fromEditMode={true}
                        defOrder={order}
                        value={reshipmentOrderValue}
                        onClose={handleOnReshipmentClose}
                        quantityFromZero={true}
                        withReshipments={true}
                        headerLabelEditing={t("admin-orders.ADD_DISH_RESHIPMENT_ORDER")}
                        onSave={handleOnSave}
                    />
                )}
                {refundOpen && (
                    <RefundOrder
                        updateItem={updateItem}
                        id={orderMenuProduct.id}
                        customerId={orderMenuProduct.customer_id}
                        maxAmount={getMaxAmount(refundId)}
                        onClose={handleOnRefundClose}
                        paymentId={refundId}
                        bonusRefund={isBonusRefund()}
                        cardTerminalRefund={isCardTerminalRefund()}
                    />
                )}
                {cancelOrderOpen && (
                    <CancelAdminOrder updateItem={updateItem} customTableConfigKey={customTableConfigKey} id={orderMenuProduct.id} onClose={handleOnCancelOrderClose} />
                )}
                {isOpenRefund && (
                    <RefundDetails
                        refunds={getRefundsById(orderRefundId)}
                        onClose={closeRefundLayout}
                        currency={order.currency}
                    />
                )}
                {!!capturePaymentId && (
                    <CapturePaymentOrder updateItem={updateItem} orderId={orderMenuProduct.id} onClose={() => setCapturePaymentId(null)} payment={getPayment(capturePaymentId)} />
                )}
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        adminOrdersLoading: state.order.data.adminOrdersLoading,
        enableCallCenterMode: state.restaurant.data.configuration && state.restaurant.data.configuration.enableCallCenterMode,
        isLoading: state.order?.data?.customTableConfigPagination?.customerService?.loadingPopup,
        territories: state.restaurant.data.territories,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getGiftCardInfo: () => dispatch(createAction(GIFT_CARD_GET)),
        getOrderInfo: data => dispatch(createAction(ADMIN_ORDER_GET_ORDER_INFO, data)),
        reshipmentOrder: data => dispatch(createAction(ADMIN_ORDER_RESHIPMENT, data)),
        getBusinessMenu: data => dispatch(createAction(BUSINESS_MENU_GET, data)),
        saveOrderToEdit: data => dispatch(resetCustomerOrderEditInfo(data)),
        onRepeatOrder: data => dispatch(createAction(REPEAT_ORDER, data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CustomerServiceOrders));
